<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-slim-face`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M36.525 7.47c-3.092-2.6-7.436-3.72-12.566-3.72h-.253C11.912 3.838 5.236 9.633 7.03 24.039c.957 7.68 3.793 13.109 7.94 16.534 2.968 2.453 6.467 3.678 8.99 3.678 2.481 0 5.915-1.24 8.858-3.712 4.083-3.43 6.953-8.85 8.07-16.494 1.152-7.872-.463-13.295-4.362-16.574zM7.785 36.089l.069.057 7.292 7.293a.5.5 0 01-.263.846l-.09.008H5a1 1 0 01-.993-.883L4 43.293v-1a1 1 0 01.883-.993L5 41.293l2-.001V36.5a.5.5 0 01.784-.411zm33.361.057a.5.5 0 01.147.354l-.001 4.792h2a1 1 0 011 1v1a1 1 0 01-1 1H33.5a.5.5 0 01-.354-.853l7.293-7.293a.5.5 0 01.707 0zM23.96 7.73c-10.393 0-14.465 4.532-13.06 15.808.8 6.431 3.03 11.056 6.524 13.943 2.096 1.732 4.72 2.791 6.536 2.791 1.75 0 4.305-1.063 6.38-2.805 3.462-2.909 5.749-7.566 6.691-14.01C38.654 12.352 34.468 7.73 23.96 7.73zm7.263 24.18a1.85 1.85 0 00-2.616-2.617 6.124 6.124 0 01-4.35 1.801 6.124 6.124 0 01-4.348-1.801 1.85 1.85 0 10-2.616 2.616 9.823 9.823 0 006.965 2.885 9.823 9.823 0 006.965-2.885z"/></svg>
</template>
<script>

export default {
  name: 'IconSlimFace',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
